module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animationload",
    class: {
      'animationload-inline': _vm.inline
    }
  }, [_c('div', {
    staticClass: "osahanloading"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "loading-text"
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08834547","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Spinner.vue
// module id = 2101
// module chunks = 1